import { chooseRelativeForXml, medcomRelationCode } from './xref01Validation';

/**
 * The clinician's explicit choice of the one Relative in the referral.
 * null = not touched (the default rule applies); 'none' = no relative.
 */
export type RelativeChoice = string | 'none' | null;

type RelationItem = { relationType: string; row: { id: string } };

/**
 * REF01 3.23: under 15 the Relative may be mor, far, værge or uspecificeret
 * pårørende (XREF01 RelationCode mor / far / uspec_paaroerende; værge has no
 * own code). Any person relation with a MedCom RelationCode may be sent.
 */
export function relationSelectableForReferral(relationType: string, under15: boolean): boolean {
  void under15;
  return medcomRelationCode(relationType) !== null;
}

/**
 * The relative that goes into the XREF01/02/06 Relative segment, or null.
 * Default: mother, else father, else the first other person relation,
 * among the selectable ones. A child must have a relative when one is
 * selectable, so 'none' is ignored under 15.
 */
export function selectedReferralRelative<T extends RelationItem>(
  relations: readonly T[],
  choice: RelativeChoice,
  under15: boolean,
): T | null {
  const selectable = relations.filter((item) =>
    relationSelectableForReferral(item.relationType, under15),
  );
  if (choice === 'none' && !under15) return null;
  if (choice && choice !== 'none') {
    const picked = selectable.find((item) => item.row.id === choice);
    if (picked) return picked;
  }
  return chooseRelativeForXml(selectable);
}

/** A "Forælder" relation does not say mother or father, so it cannot be RelationCode mor/far. */
export function hasUnspecifiedParentRelation(relationTypes: readonly string[]): boolean {
  return relationTypes.includes('parent');
}
